module.exports = __webpack_public_path__ + "img/sfq-h7.0ae1a222.png";